"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Reporter = /** @class */ (function () {
    function Reporter(destinationUrl) {
        this.destinationUrl = destinationUrl;
    }
    Reporter.prototype.reportEvent = function (event) {
        if (this.destinationUrl === undefined || this.destinationUrl === null || this.destinationUrl === '') {
            return;
        }
        try {
            var req = new XMLHttpRequest();
            req.onerror = this.logError;
            req.open('PUT', this.destinationUrl, true);
            req.setRequestHeader('Content-Type', 'application/json');
            req.send(JSON.stringify([event]));
        }
        catch (e) {
            // Log the error, but don't crash the thread that this was called from.
            this.logError(e);
        }
    };
    Reporter.prototype.postEvent = function (event) {
        if (this.destinationUrl === undefined || this.destinationUrl === null || this.destinationUrl === '') {
            return;
        }
        try {
            var req = new XMLHttpRequest();
            req.onerror = this.logError;
            req.open('POST', this.destinationUrl, true);
            req.setRequestHeader('Content-Type', 'application/json');
            req.send(JSON.stringify([event]));
        }
        catch (e) {
            // Log the error, but don't crash the thread that this was called from.
            this.logError(e);
        }
    };
    Reporter.prototype.logError = function (message) {
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        if (window.console) {
            window.console.error(message, optionalParams);
        }
    };
    return Reporter;
}());
exports.Reporter = Reporter;
//# sourceMappingURL=Reporter.js.map